import React, {useEffect} from 'react'
import classes from './css/SectionThree.module.css'
import style from './css/SectionFour.module.css'
import Aos from 'aos'
import "aos/dist/aos.css"
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Link} from "react-router-dom";

interface Props {
    companies: {
        companyName: string,
        id: string,
        picture: string,
    }[]
}

function SampleNextArrow(props: any) {
    const {className, onClick} = props;
    return (
            <div
                    className={className + " bfnone"}

                    onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="25" height="25" x="0" y="0"
                     viewBox="0 0 443.52 443.52">
                    <g>
                        <g xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <path
                                        d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734    L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8    C342.889,227.058,342.889,216.255,336.226,209.591z"
                                        fill="rgba(255,255,255,0.8)" data-original="#000000" className=""></path>
                            </g>
                        </g>

                    </g>
                </svg>

            </div>
    );
}

function SamplePrevArrow(props: any) {
    const {className, onClick} = props;
    return (
            <div
                    className={className + " bfnone"}

                    onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="25" height="25" x="0" y="0"
                     viewBox="0 0 443.52 443.52">
                    <g>
                        <g xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8    c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712    L143.492,221.863z"
                                      fill="rgba(255,255,255,0.8)" data-original="#000000"></path>
                            </g>
                        </g>

                    </g>
                </svg>
            </div>
    );
}

export const SectionFour: React.FC<Props> = (props) => {
    useEffect(() => {
        Aos.init({duration: 1300, once: false})
    }, [])
    var settings = {
        dots: true,
        infinite: true,
        loop: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: props.companies.length < 4 ? 1 : 4,
        slidesToScroll: 1,
        initialSlide: 0,
        rtl: true,
        nextArrow: <SampleNextArrow/>,
        prevArrow: <SamplePrevArrow/>,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: props.companies.length < 4 ? 1 : 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: props.companies.length < 4 ? 1 : 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };
    return (
            <section className={"secFour  " + style.SectionFour}>

                <div className={'w-100  ' + classes.second} data-aos="fade-up">
                    <h1>اهم الشركات والمصانع التي تستخدم وظائف السادات</h1>


                    <div className={classes.btnsDiv} data-aos="fade-up">
                        <div className={'container  p-0 m-0  '}>
                            <Slider {...settings}>

                                {props.companies.map((com) => {
                                    return (
                                            <div key={com.id} className={'d-flex justify-content-center'}>
                                                <Link to={`/company/${com.id}`} className={style.companylogo}>
                                                    <img src={`${com.picture}`} alt={com.companyName}/>
                                                    <p className={"p-0 m-0 text-white"}>{com.companyName}</p>
                                                </Link>
                                            </div>
                                    )
                                })}


                            </Slider>
                        </div>
                    </div>
                </div>

            </section>
    )
}


